import { Navigate, useLocation } from 'react-router'
import { useAuth } from '../lib/auth.js'
import { LoadingState } from '../components/LoadingState.js'

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  // Distinguishing loading from unauthenticated matters: redirecting during the /api/me
  // round trip bounces a signed-in user to the login screen on every refresh.
  if (isLoading) return <LoadingState label="Loading your workspace" />
  if (user === null) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  return <>{children}</>
}
